import { css } from 'styled-components';
import { CFTokens } from '../../tokens';
import { CFBaseAccordionHelpers, CFBaseAccordionTokens } from './styles';
export const CFBaseAccordionStyles = {
    Divider: css `
    position: absolute;
    ${CFBaseAccordionHelpers.dividerPosition}
  `,
    Panel: css `
    box-sizing: border-box;
    padding: ${CFBaseAccordionTokens.PADDING.BLOCK_PANEL_TOP}px
      ${CFBaseAccordionTokens.PADDING.INLINE}px
      ${CFBaseAccordionTokens.PADDING.BLOCK_PANEL_BOTTOM}px;
    width: 100%;
    overflow: hidden;
  `,
    Root: css `
    box-sizing: border-box;
    position: relative;
    overflow: hidden;
    background-color: ${CFBaseAccordionTokens.BACKGROUND_COLOR.DEFAULT};
    ${CFBaseAccordionHelpers.rootBorder}
  `,
    RootNative: css `
    ${CFBaseAccordionHelpers.rootSizeNative};
  `,
    RootWeb: css `
    ${CFBaseAccordionHelpers.rootSizeWeb};
  `,
    Trigger: css `
    box-sizing: border-box;
    padding: 0;
    width: 100%;
    border: 0;
    background-color: transparent;
    outline: 0;
    ${CFBaseAccordionHelpers.triggerBorderRadius};
  `,
    TriggerIconWrapper: css `
    border-radius: ${CFBaseAccordionTokens.BORDER_RADIUS.TRIGGER_ICON}px;
  `,
    TriggerIconWrapperNative: css `
    ${CFBaseAccordionHelpers.triggerIconWrapperInteractionsNative}
  `,
    TriggerIconWrapperWeb: css `
    background-color: ${CFBaseAccordionHelpers.backgroundColor};
    ${CFBaseAccordionHelpers.triggerIconWrapperInteractionsWeb};
  `,
    TriggerLabel: css `
    box-sizing: border-box;
    padding: ${CFBaseAccordionTokens.PADDING.BLOCK_TRIGGER}px 0;
    flex: 1;
  `,
    TriggerRoot: css `
    box-sizing: border-box;
    padding: 0 ${CFBaseAccordionTokens.PADDING.INLINE}px;
    width: 100%;
    display: flex;
    gap: ${CFTokens.SPACER.D}px;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    ${CFBaseAccordionHelpers.triggerBorderRadius};
  `,
    TriggerRootNative: css `
    ${CFBaseAccordionHelpers.triggerWrapperInteractionsNative}
  `,
    TriggerRootWeb: css `
    ${CFBaseAccordionHelpers.triggerWrapperInteractionsWeb}
  `,
};
